import PropTypes from 'prop-types';

import { HBox } from './HBox';
import { Avatar, Typography } from '@mui/joy';
import { VBox } from './VBox';

export function UserView({
    user
}) {
    return (
        <HBox sx={{ gap: 1 }}>
            <Avatar size="sm" src={user.image_url} />
            <VBox sx={{ flex: 1 }}>
                {(user?.first_name || user?.last_name) ? (
                    <Typography>{user?.first_name} {user?.last_name}</Typography>
                ): <Typography>{user?.username}</Typography>}
                {user?.role && <Typography>{user?.role}</Typography>}
            </VBox>
        </HBox>
    )
}

UserView.propTypes = {
    user: PropTypes.object
}